export default __webpack_public_path__ + "static/media/img-mwa-user-experience-04.f2ad68b5.png";